export const ist = {
    MixDiagrammStromverbrauchClass: {
        url: "Diagramm/stromverbrauch",
        defaultSegment: "Diagramm",
        forceRefresh: false,
        receiveType: 'RECEIVE_MixDiagrammStromverbrauchClass_stromReducer'
    }
};